import constants from '../constants.js';

export const types = {
  GET_SPACES: 'CUSTOMER/GET_SPACES',
  GET_SPACES_SUCCESS: 'CUSTOMER/GET_SPACES_SUCCESS',
  GET_SPACES_ERROR: 'CUSTOMER/GET_SPACES_ERROR',
  CREATE_WORK_REQUEST: 'CUSTOMER/CREATE_WORK_REQUEST',
  CREATE_WORK_REQUEST_SUCCESS: 'CUSTOMER/CREATE_WORK_REQUEST_SUCCESS',
  CREATE_WORK_REQUEST_ERROR: 'CUSTOMER/CREATE_WORK_REQUEST_ERROR',
  CLEAR_REQUEST_CREATED: 'CUSTOMER/CLEAR_REQUEST/CREATED',
};

const initialState = {
  spaces: {
    loaded: constants.UNLOADED,
    data: {},
  },
  createdWorkRequests: {
    loaded: constants.LOADED,
    requestCreated: false,
    photoFailed: false,
    data: {},
    jobs: [],
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  let httpCode, loaded;

  switch (type) {
    case types.GET_SPACES:
      return {
        ...state,
        spaces: {
          ...state.spaces,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_SPACES_SUCCESS:
      return {
        ...state,
        spaces: {
          ...state.spaces,
          loaded: constants.LOADED,
          data: payload.data,
        },
      };
    case types.GET_SPACES_ERROR:
      return {
        ...state,
        spaces: {
          ...state.spaces,
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.CREATE_WORK_REQUEST:
      return {
        ...state,
        createdWorkRequests: {
          loaded: constants.UNLOADED,
          data: payload.data,
          jobs: state.createdWorkRequests.jobs,
        },
      };
    case types.CREATE_WORK_REQUEST_SUCCESS:
      return {
        ...state,
        createdWorkRequests: {
          photoFailed: payload.data.warning == 'photofailure' ? true : false,
          requestCreated: true,
          loaded: constants.LOADED,
          jobs: state.createdWorkRequests.jobs.concat(
            payload.data['work-request'].jobs
          ),
        },
      };
    case types.CREATE_WORK_REQUEST_ERROR:
      return {
        ...state,
        spaces: {
          loaded: constants.FAILED_FATAL,
        },
        createdWorkRequests: {
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.CLEAR_REQUEST_CREATED:
      return {
        ...state,
        createdWorkRequests: {
          ...state.createdWorkRequests,
          requestCreated: false,
        },
      };
  }

  return state;
}

export const actions = {
  getSpaces: () => ({
    type: types.GET_SPACES,
  }),
  createWorkRequest: (data) => ({
    type: types.CREATE_WORK_REQUEST,
    payload: { data },
  }),
  clearRequestCreated: () => ({
    type: types.CLEAR_REQUEST_CREATED,
  }),
};
